import React from 'react'
import { NavLink, useLocation } from 'react-router-dom'

const AcademicsLayout = ({children}) => {
    const location = useLocation();
    const currentRoute = location.pathname;
    return (
        <div>
            <div className='h-[50px] w-full flex items-center'>
                <NavLink  to="/admin/academics/dashboard"  className={`font-medium text-sm nav-button px-3 py-3  ${currentRoute.includes('admin/academics/dashboard') ? 'border-b-2 border-vcm-purple text-vcm-purple' : 'border-b border-gray-300 text-gray-600'}`}>Academics Dashboard</NavLink>

                <NavLink  to="/admin/academics/subjects"  className={`font-medium text-sm nav-button px-3 py-3  ${currentRoute.includes('admin/academics/subjects') ? 'border-b-2 border-vcm-purple text-vcm-purple' : 'border-b border-gray-300 text-gray-600'}`}>Subjects</NavLink>

                {/* <NavLink  to="/admin/academics/timetables" className={`font-medium text-sm nav-button px-3 py-3  ${currentRoute.includes('admin/academics/timetables') ? 'border-b-2 border-vcm-purple text-vcm-purple' : 'border-b border-gray-300 text-gray-600'}`}>Timetables</NavLink> */}

                <NavLink  to="/admin/academics/assessments" className={`font-medium text-sm nav-button px-3 py-3  ${currentRoute.includes('admin/academics/assessments') ? 'border-b-2 border-vcm-purple text-vcm-purple' : 'border-b border-gray-300 text-gray-600'}`}>Assessments</NavLink>
                
                <NavLink  to="/admin/academics/academic-settings" className={`font-medium text-sm nav-button px-3 py-3  ${currentRoute.includes('admin/academics/academic-settings') ? 'border-b-2 border-vcm-purple text-vcm-purple' : 'border-b border-gray-300 text-gray-600'}`}>Academic Settings</NavLink>
                
            </div>
            <div className={`mt-10 min-h-screen`}>
                <main>{children}</main>
            </div>
        </div>
    )
}

export default AcademicsLayout